import {myEnrollmentsApi} from '@/api/my-enrollments.api.js'
import {useFlashMessages} from '@/composables/use-flash-messages.js'
import {ref} from 'vue'

/**
 * Enrollment management composable
 */
export function useEnrollmentManagement(enrollment) {

  //Composables
  const {setFlashSuccess, setFlashFailure} = useFlashMessages()

  //Updating enrollment flag
  const isUpdatingEnrollment = ref(false)

  //Update unread state
  const updateIsUnread = async isUnread => {

    //Must have enrollment with ID
    if (!enrollment.value?.id) {
      throw new Error(`Must have enrollment with ID`)
    }

    //Extract ID
    const {id} = enrollment.value

    //Toggle flag
    isUpdatingEnrollment.value = true

    //Update
    try {
      await myEnrollmentsApi.updateById(id, {isUnread})
      enrollment.value.isUnread = isUnread
    }
    finally {
      isUpdatingEnrollment.value = false
    }
  }

  //Start or stop enrollment
  const isStartingOrStoppingEnrollment = ref(false)
  const startOrStopEnrollment = async () => {

    //Must have enrollment with ID
    if (!enrollment.value?.id) {
      throw new Error(`Must have enrollment with ID`)
    }

    //Extract ID
    const {id} = enrollment.value

    //Toggle flag
    isStartingOrStoppingEnrollment.value = true

    //Start/stop enrollment
    try {
      const json = await myEnrollmentsApi.startOrStopEnrollment(id)
      const {status, pausedAt} = json.enrollment
      enrollment.value.status = status
      enrollment.value.pausedAt = pausedAt
    }
    finally {
      isStartingOrStoppingEnrollment.value = false
    }
  }

  //Resend last message
  const isResendingLastMessage = ref(false)
  const resendLastMessage = async () => {

    //Must have enrollment with ID
    if (!enrollment.value?.id) {
      throw new Error(`Must have enrollment with ID`)
    }

    //Extract ID
    const {id} = enrollment.value

    //Toggle flag
    isResendingLastMessage.value = true

    //Resend last message
    try {
      await myEnrollmentsApi.resendLastMessage(id)
      setFlashSuccess('Resent the last message')
    }
    catch {
      setFlashFailure('Failed to resend last message')
    }
    finally {
      isResendingLastMessage.value = false
    }
  }

  //Expose interface
  return {

    //Enrollment updates
    updateIsUnread,
    isUpdatingEnrollment,

    //Start/stop enrollment
    startOrStopEnrollment,
    isStartingOrStoppingEnrollment,

    //Resend last message
    resendLastMessage,
    isResendingLastMessage,
  }
}
